// ─── HERO ELECTRICAL DISCHARGE — bold fork lightning ────────────────────────
// Ported from the dashboard login's login-lightning.js (2026-08-28) at the
// owner's request: same bold look — deeper forks, thicker glow, occasional
// double strikes, faint green sky-flash per strike, dramatic 2.2–6.5 s cadence.
// Public-page cost guards (ported with it): rAF loop runs ONLY while bolts or
// the flash are alive (setTimeout re-arms the next strike — zero idle CPU);
// renders nothing under prefers-reduced-motion; pauses + clears when the tab
// is hidden; DPR capped at 1.5. Theme-aware: dark = additive white/mint,
// light = brand green.
(function () {
  function init(canvas) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ctx = canvas.getContext('2d');
    var DPR = Math.min(window.devicePixelRatio || 1, 1.5);
    var W = 0, H = 0, bolts = [], raf = null, timer = null, flash = 0;

    function rand(a, b) { return a + Math.random() * (b - a); }

    function resize() {
      var hero = canvas.parentElement;
      W = hero.offsetWidth || hero.clientWidth;
      H = hero.offsetHeight || hero.clientHeight;
      if (W === 0 || H === 0) {
        // Fallback if parent dimensions aren't ready yet
        var rect = hero.getBoundingClientRect();
        W = rect.width;
        H = rect.height;
      }
      canvas.width = Math.round(W * DPR);
      canvas.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }

    // Recursive fractal fork: midpoint displacement + occasional branches
    function buildBolt(x1, y1, x2, y2, depth, spread, segs) {
      if (depth === 0 || (Math.abs(x2 - x1) < 3 && Math.abs(y2 - y1) < 3)) {
        segs.push([x1, y1, x2, y2]);
        return;
      }
      var mx = (x1 + x2) / 2 + rand(-spread, spread);
      var my = (y1 + y2) / 2 + rand(-spread, spread);
      buildBolt(x1, y1, mx, my, depth - 1, spread * 0.55, segs);
      buildBolt(mx, my, x2, y2, depth - 1, spread * 0.55, segs);
      if (depth >= 3 && Math.random() < 0.45) {
        var bx = mx + rand(-spread * 2.2, spread * 2.2);
        var by = my + rand(-spread * 1.8, spread * 1.8);
        buildBolt(mx, my, bx, by, depth - 2, spread * 0.5, segs);
      }
    }

    function spawnBolt() {
      var side = Math.random(), ox, oy, tx, ty;
      if (side < 0.55) {          // sky → down, forking toward mid-hero
        ox = rand(-40, W * 0.9);
        oy = rand(-60, -10);
        tx = ox + rand(-W * 0.18, W * 0.18);
        ty = rand(H * 0.45, H * 0.95);
      } else if (side < 0.8) {    // edge → across
        var fromLeft = Math.random() < 0.5;
        ox = fromLeft ? rand(-30, 10) : rand(W - 10, W + 30);
        oy = rand(-20, H * 0.5);
        tx = fromLeft ? rand(W * 0.4, W * 1.05) : rand(-W * 0.05, W * 0.6);
        ty = rand(H * 0.2, H * 0.9);
      } else {                     // interior arc
        ox = rand(W * 0.15, W * 0.85);
        oy = rand(H * 0.1, H * 0.6);
        tx = ox + rand(-260, 260);
        ty = oy + rand(120, H * 0.5);
      }
      var segs = [];
      buildBolt(ox, oy, tx, ty, Math.floor(rand(6, 9)), rand(34, 80), segs);
      bolts.push({ segs: segs, peak: rand(0.7, 0.95), life: rand(1000, 2400), born: performance.now() });
    }

    function strike() {
      spawnBolt();
      if (Math.random() < 0.35) spawnBolt();   // occasional double strike
      flash = Math.min(flash + rand(0.05, 0.09), 0.12);
      if (!raf) raf = requestAnimationFrame(draw);
    }

    function schedule() {
      timer = setTimeout(function () {
        strike();
        timer = setTimeout(schedule, rand(0, 1800)); // chain: strike, then re-arm
      }, rand(2200, 6500));
    }

    function draw(now) {
      ctx.clearRect(0, 0, W, H);
      bolts = bolts.filter(function (b) { return now - b.born < b.life; });

      // sky flash — fast decay, very low alpha (hero bg is black in both themes)
      if (flash > 0.003) {
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(43,181,128,' + flash.toFixed(3) + ')';
        ctx.fillRect(0, 0, W, H);
        flash *= 0.82;
      }

      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.globalCompositeOperation = 'lighter';   // hero bg is black in BOTH themes

      for (var i = 0; i < bolts.length; i++) {
        var b = bolts[i];
        var t = (now - b.born) / b.life;
        var a = t < 0.07 ? (t / 0.07) * b.peak
                          : b.peak * Math.pow(1 - (t - 0.07) / 0.93, 2.6);
        if (a <= 0) continue;

        // outer glow → mid → white core, three passes — dashboard-vivid in both
        // themes (the light-mode dimming made bolts read as blurry on the store)
        var passes = [
          ['rgba(43,181,128,' + (a * 0.55).toFixed(3) + ')', 12],
          ['rgba(140,255,200,' + (a * 0.85).toFixed(3) + ')', 4.5],
          ['rgba(255,255,255,' + a.toFixed(3) + ')', 1.7]
        ];
        for (var p = 0; p < passes.length; p++) {
          ctx.strokeStyle = passes[p][0];
          ctx.lineWidth = passes[p][1];
          ctx.beginPath();
          for (var s = 0; s < b.segs.length; s++) {
            ctx.moveTo(b.segs[s][0], b.segs[s][1]);
            ctx.lineTo(b.segs[s][2], b.segs[s][3]);
          }
          ctx.stroke();
        }
      }

      ctx.globalCompositeOperation = 'source-over';

      if (bolts.length > 0 || flash > 0.003) {
        raf = requestAnimationFrame(draw);
      } else {
        raf = null;                 // idle: stop the loop, timer re-arms
      }
    }

    window.addEventListener('resize', resize);
    resize();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        if (timer) { clearTimeout(timer); timer = null; }
        bolts = []; flash = 0;
        ctx.clearRect(0, 0, W, H);
      } else {
        schedule();
      }
    });

    // first strike shortly after load, then bold random cadence
    setTimeout(function () { strike(); schedule(); }, rand(500, 1500));
  }

  // Initialize all lightning canvases on the page
  function initAll() {
    document.querySelectorAll('.hero-lightning-canvas').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
